export const STORAGE_KEYS = {
    APP_INITIALIZED: 'app-initialized',
    JWT: 'jwt',
    JWT_RENEW: 'jwt-r',
    USER: 'user',
    USER_DETAILS: 'user-details',
    ACTIVITY: 'activity',
    ACCIDENT_TYPE: 'accident_type',
    PATHOLOGY: 'pathology',
    MESSAGE_LANGS: 'message-langs',
    MESSAGE_TYPES: 'message-types',
    OVERLAY_SRV: 'overlay-srv',
    OVERLAY_INT_TYPES: 'overlay-int-types',
    MAP_SRV: 'map-srv',
    TODAY: 'today',
    EVENT_OVERLAY_TYPE: 'event-overlay-type',
    HELICO: 'helico',
    squad: 'squad',
    LAST_USER: 'last-user',
    GEOIP: 'geoip',
    PENDING_REQUEST: 'pendind-request',
    REDIRECT_AFTER_LOGIN: 'redirect-after-login',
    HIDE_CLOSED_EVENTS: 'hide-closed-events'
};

export const Storage = {
    store: (key, data, sessionScoped = false) => {
        const storage = sessionScoped ? sessionStorage : localStorage;
        storage.setItem(key, JSON.stringify(data));
    },

    get: (key) => {
        const data = sessionStorage.getItem(key) ?? localStorage.getItem(key);

        if (data === null) { return null; }

        try {
            return JSON.parse(data);
        } catch (e) {
            return data;
        }
    },

    clear: (key) => {
        sessionStorage.removeItem(key);
        localStorage.removeItem(key);
    },

    clearAll: () => {
        sessionStorage.clear();
        localStorage.clear();
    }
}